









import { computed, defineComponent, inject, Ref } from '@nuxtjs/composition-api';
import { useQuery } from 'villus';
import type { ProductData } from '~/features/product';
import { mapProductListing } from '~/features/products';
import { RelatedProductsDocument } from '~/graphql/Product';
import { toNonNullable } from '~/utils/collections';
import { PRODUCT_CONTEXT } from '~/utils/provides';

export default defineComponent({
  name: 'ProductPageSuggestions',
  setup() {
    const product = inject(PRODUCT_CONTEXT) as Ref<ProductData>;
    const { data, error, isFetching } = useQuery({
      query: RelatedProductsDocument,
      variables: {
        slug: product.value.url_key as string,
      },
    });

    if (error.value) {
      // eslint-disable-next-line no-console
      console.log(error.value);
    }

    const items = computed(() => {
      return toNonNullable(data.value?.product?.items).map(mapProductListing);
    });

    return {
      items,
      isFetching,
    };
  },
});
